import { ShippingClaimSchema } from "@redotech/redo-package-protection-common/shipping-claims/shipping-claim";
import * as z from "zod";

const MerchantShippingClaimUpdateSchema = z.object({
  shippingClaimId: z.string(),
  merchantInternalNotes: z.string().nullish(),
});

export type MerchantShippingClaimUpdate = z.infer<
  typeof MerchantShippingClaimUpdateSchema
>;

export const updateMerchantShippingClaims = {
  name: "updateMerchantShippingClaims" as const,
  input: z.object({ updates: z.array(MerchantShippingClaimUpdateSchema) }),
  output: z.record(z.string(), ShippingClaimSchema),
};
